import { IconWrapper } from '../runtime';
export default IconWrapper('members-super-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8.91564 0.251649L14.0844 3.31248C14.651 3.64801 15 4.2681 15 4.93917V11.0608C15 11.7319 14.651 12.352 14.0844 12.6875L8.91564 15.7484C8.34904 16.0839 7.65096 16.0839 7.08436 15.7484L1.91564 12.6875C1.34904 12.352 1 11.7319 1 11.0608V4.93917C1 4.2681 1.34904 3.64801 1.91564 3.31248L7.08436 0.251649C7.65096 -0.0838831 8.34904 -0.0838831 8.91564 0.251649Z",
      "fill": "#262018"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.83137 6.43765L10.8099 8.70786C10.9295 8.77612 11.0033 8.90326 11.0033 9.04097V10.4326C11.0033 10.5719 10.9277 10.7003 10.8058 10.768L8.25292 12.184C8.09651 12.2708 7.90613 12.2695 7.75088 12.1807L5.20865 10.7258C5.08928 10.6575 5.01562 10.5304 5.01562 10.3929V9.02755C5.01562 8.92164 5.10148 8.83579 5.20739 8.83579C5.2408 8.83579 5.27363 8.84452 5.30263 8.86112L7.81288 10.2977C7.9296 10.3645 8.07277 10.3653 8.19021 10.2998L9.0343 9.82895C9.09596 9.79455 9.11807 9.71669 9.08367 9.65503C9.07246 9.63493 9.05603 9.61823 9.03612 9.60669L5.20687 7.38792C5.0885 7.31933 5.01562 7.19288 5.01562 7.05608V5.58572C5.01562 5.44818 5.08928 5.32117 5.20865 5.25285L7.74695 3.80021C7.90431 3.71015 8.0976 3.71015 8.25496 3.80022L10.8211 5.26899C10.9413 5.33775 11.0151 5.46594 11.0141 5.60437L11.0054 6.92532C11.0047 7.03122 10.9183 7.11651 10.8124 7.11581C10.78 7.1156 10.7481 7.10716 10.7198 7.09128L8.18779 5.67016C8.07168 5.605 7.93008 5.60471 7.81371 5.66941L6.83261 6.21488C6.7709 6.24919 6.74869 6.32703 6.783 6.38874C6.79435 6.40916 6.81108 6.42607 6.83137 6.43765Z",
      "fill": 'url(#' + props.id + 'b2001e1c' + ')'
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'b2001e1c',
      "x1": "3.11126",
      "y1": "6.10385",
      "x2": "8.66869",
      "y2": "13.9149",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#F7D6A9"
    }
  }), h("stop", {
    "attrs": {
      "offset": "0.530113",
      "stop-color": "#FFC87C"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#D99C46"
    }
  })])])]);
});